import { connect } from 'react-redux';
import HomePageNew from 'pages/HomePageNew';
import AuthActions from 'store/auth/actions';
import homePageNewActions from 'store/homePageNew/actions';
import newOlsActions from 'store/newOls/actions';
import buddyReferralActions from 'store/buddyReferral/actions';

const mapStateToProps = state => {
  return {
    mvpTrainingData: state.homePageNew.mvpTrainingData,
    profileDetails: state?.auth?.profile,
    buddyReferralDetails: state?.buddyReferral?.buddyReferralDetails,
  };
};
const mapDispatchToProps = {
  getMvpTraningData: homePageNewActions.Creators.loadMvpTrainingRequest,
  logout: AuthActions.Creators.logoutRequest,
  resetState: AuthActions.Creators.resetState,
  loadProfile: AuthActions.Creators.loadProfileRequest,
  getQRCode: homePageNewActions.Creators.loadQRCodeRequest,
  loadBuddyReferralDetails: buddyReferralActions.Creators.loadBuddyReferralRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePageNew);
